(() => {
  if (window.OBHomeLoaded) return;
  window.OBHomeLoaded = true;

  // Shopify supplies newest additions first. Round-robin selection stops one
  // brand from occupying the entire shelf; no sales ranking is implied.
  function mixBrands(result, limit) {
    const groups = new Map(), seen = new Set(), cards = [];
    result.querySelectorAll('[data-ob-product-id]').forEach(item => {
      const card = item.querySelector('.ob-product'), id = item.dataset.obProductId;
      if (!card || seen.has(id)) return;
      seen.add(id);
      const brand = (item.dataset.obVendor || '').trim().toLowerCase();
      if (!groups.has(brand)) groups.set(brand, []);
      groups.get(brand).push(card);
    });
    while (cards.length < limit) {
      let added = false;
      for (const group of groups.values()) {
        if (group.length) { cards.push(group.shift()); added = true; }
        if (cards.length === limit) break;
      }
      if (!added) break;
    }
    return cards;
  }

  async function loadProducts(section) {
    if (section.dataset.loadingStarted) return;
    section.dataset.loadingStarted = 'true';
    const grid = section.querySelector('[data-featured-grid]');
    const status = section.querySelector('[data-featured-status]');
    try {
      const url = new URL(section.dataset.productsUrl, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid collection URL');
      url.searchParams.set('sort_by', 'created-descending');
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.set('view', 'ob-featured');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000) });
      if (!response.ok) throw new Error('Unable to load products');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const result = html.querySelector('[data-ob-featured-results]');
      if (!result) throw new Error('Missing products');
      const limit = Math.min(24, Math.max(4, Number(section.dataset.productLimit) || 12));
      const cards = mixBrands(result, limit);
      if (!section.isConnected) return;
      grid.replaceChildren(...cards);
      status.textContent = cards.length ? '' : 'No products are available yet.';
      status.hidden = cards.length > 0;
    } catch (error) {
      if (!section.isConnected) return;
      grid.replaceChildren();
      status.textContent = 'Please use View all to browse available products.';
    } finally {
      grid.setAttribute('aria-busy', 'false');
    }
  }

  function init(root) { root.querySelectorAll('[data-ob-featured]').forEach(loadProducts); }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
